<template>
  <v-row class="timer-week-bar align-center" no-gutters>
    <v-col cols="auto" class="timer-week-nav-col">
      <v-btn
        fab
        small
        class="timer-week-nav"
        color="white"
        @click="gotoLastWeek(selectedDate)"
      >
        <v-icon large color="black" tile>mdi-chevron-left</v-icon>
      </v-btn>
    </v-col>

    <v-col v-for="day in daysInWeek" v-bind:key="day.id" class="timer-week-day">
      <v-btn :class="dayButtonClass(day)" @click="goToDate(day.date)">
        <span v-if="day.date === dateToday" class="timer-week-today">
          TODAY
        </span>
        <span>{{ day.day }}</span>
        <span>{{ day.date }}</span>
      </v-btn>
    </v-col>

    <v-col cols="auto" class="timer-week-nav-col">
      <v-btn
        fab
        small
        class="timer-week-nav"
        color="white"
        @click="gotoNextWeek(selectedDate)"
      >
        <v-icon large color="black" tile>mdi-chevron-right</v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import {
  GetSelectedWeekData,
  NextDayFromSelectedDate,
  PreviousDayFromSelectedDate,
  today,
} from "@/Utilites/timerHelper";

export default {
  name: "TimerPageWeekBar",
  data() {
    return {
      daysInWeek: [],
      dateToday: "",
      selectedDate: "",
    };
  },
  props: ["changeDate"],
  mounted() {
    this.dateToday = today();
    this.selectedDate = today();
    this.getWeekList(this.dateToday);
  },
  watch: {
    changeDate: function () {
      this.filterTimerByDate(this.changeDate);
    },
  },
  methods: {
    goToDate(date) {
      this.filterTimerByDate(date);
    },
    gotoLastWeek() {
      this.filterTimerByDate(PreviousDayFromSelectedDate(this.selectedDate));
    },
    gotoNextWeek() {
      this.filterTimerByDate(NextDayFromSelectedDate(this.selectedDate));
    },
    dayButtonClass(day) {
      const selected = day.date === this.selectedDate;
      const today = day.date === this.dateToday;
      return [
        "timer-week-button",
        "text-caption",
        selected && today
          ? "blue darken-2 text-white"
          : today
          ? "blue lighten-1 text-white"
          : selected
          ? "green"
          : "",
      ];
    },
    getWeekList(date) {
      this.daysInWeek = GetSelectedWeekData(date);
    },
    filterTimerByDate(date) {
      this.selectedDate = date;
      this.getWeekList(date);
      this.$emit("goto-date", date);
    },
  },
};
</script>

<style scoped>
.timer-week-bar {
  margin: 0 auto 16px;
  width: min(100%, 1480px);
}

.timer-week-day {
  display: flex;
  flex: 1 1 0;
  justify-content: center;
  min-width: 0;
  padding: 0 3px;
}

.timer-week-nav-col {
  padding: 0 4px;
}

.timer-week-button {
  font-size: clamp(0.58rem, 0.9vw, 0.75rem) !important;
  height: auto !important;
  line-height: 1.1;
  min-height: clamp(46px, 5vw, 58px);
  min-width: 0 !important;
  padding: 4px 2px !important;
  white-space: normal;
  width: 100%;
  max-width: 100px;
}

.timer-week-button::v-deep .v-btn__content {
  align-items: center;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  white-space: normal;
}

.timer-week-nav {
  width: clamp(32px, 4vw, 40px);
  height: clamp(32px, 4vw, 40px);
}

.timer-week-today {
  display: block;
  white-space: nowrap;
}
</style>
